const PRIME_PAYMENTFLOW_START_EVENT_NAME = 'prime_paymentflow_start';
const PRIME_PAYMENTFLOW_STOP_EVENT_NAME = 'prime_paymentflow_stop';
const TOI_SUBSCRIPTION_START_EVENT_NAME = 'toi_subscriptionflow_start';

export function primePaymentflowStartEmitter(dataObj) {
  const primepaymentflowstartEvent = new CustomEvent(
    PRIME_PAYMENTFLOW_START_EVENT_NAME,
    {
      detail: dataObj,
    },
  );
  window.dispatchEvent(primepaymentflowstartEvent);
}
export function primePaymentflowStopEmitter(dataObj) {
  const primepaymentflowstopEvent = new CustomEvent(
    PRIME_PAYMENTFLOW_STOP_EVENT_NAME,
    {
      detail: dataObj,
    },
  );
  window.dispatchEvent(primepaymentflowstopEvent);
}

//This event is to start the flow of Toi Subscription
// here we pass screenType which controls which screen to be shown
export function toiSubscriptionflowStartEmitter(dataObj) {
  const toiPlusSubscriptionflowStartEvent = new CustomEvent(
    TOI_SUBSCRIPTION_START_EVENT_NAME,
    { detail: dataObj },
  );
  window.dispatchEvent(toiPlusSubscriptionflowStartEvent);
}
